
type Summary =  {
    row: number[];
    col: number[];
};

type Gameboard = {
    matrix: number[][];
    points: number[][];
    summary: Summary;
};

const emptyGameboard: Gameboard = {
    matrix: [],
    points: [],
    summary: {
        row: [],
        col: [],
    },
}

export type { Summary, Gameboard };

export { emptyGameboard };
